import React, { useState, useEffect, useMemo, memo } from 'react';
import { Modal, Row, Col, Tab, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import {
  getRequest,
  postRequest,
  deleteRequest,
} from '../../../utils/axiosRequests';
import { useGetRequest } from '../../../hooks/useGetRequest';
import NoteDropdown from '../partials/noteDropdown';
import InfertilityGroupForm from './infertilityGroupForm';
import ItemWithDeleteIcon from '../partials/itemWithDeleteIcon';
import GroupDropdownItem from '../partials/groupDropdownItem';
import LoadMore from '../partials/loadMore';
import ModalHeader from '../partials/modalHeader';
import SearchArea from '../partials/searchArea';
import InfertilityTabNav from '../partials/infertilityTabNav';

const InfertilityModal = ({
  modalTitle,
  selectedInfertilities,
  setSelectedInfertilities,
  selectedInfertilityWomenGroups,
  setSelectedInfertilityWomenGroups,
  selectedInfertilityManGroups,
  setSelectedInfertilityManGroups,
  showInfertility,
  setShowInfertility,
}) => {
  const [infertilitiesForWoman, setInfertilitiesForWoman] = useState([]);
  const [infertilitiesForMan, setInfertilitiesForMan] = useState([]);
  const [infertilitiesInSearch, setInfertilitiesInSearch] = useState([]);
  const [groupsForMan, setGroupsForMan] = useState([]);
  const [groupsForWoman, setGroupsForWoman] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [isInfertilityGroupModal, setIsInfertilityGroupModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItem, setTotalItem] = useState(0);
  const [tabKey, setTabKey] = useState('woman');
  const perPage = 40;
  let selectedManData = selectedInfertilities?.man || [];
  let selectedWomanData = selectedInfertilities?.woman || [];
  const allNotes = useSelector((state) => state?.prescriptionReducer?.prescriptionInfo?.itemElementNotes || []);

  const elementSuggestions = useMemo(() => {
    const map = {};
    allNotes.filter((n) => n.elementType === 'infertility').forEach((n) => {
      if (!map[n.itemElement]) map[n.itemElement] = new Set();
      map[n.itemElement].add(n.note);
    });
    return Object.entries(map).map(([id, notesSet]) => ({ _id: id, notes: [...notesSet] }));
  }, [allNotes]);
  const mergeGroup = (data) => {
    groupTabKey() === 'man'
      ? setGroupsForMan([...groupsForMan, data])
      : setGroupsForWoman([...groupsForWoman, data]);
  };

  const { isLoading: isAdviceLoading, refetch: getInfertilityList } =
    useGetRequest(
      'getInfertilityList',
      `infertilities?type=${tabKey}&page=${currentPage}&perPage=${perPage}`,
      (data) => {
        if (currentPage > 1) {
          tabKey === 'man'
            ? setInfertilitiesForMan(data.data)
            : setInfertilitiesForWoman(data.data);
        } else {
          tabKey === 'man'
            ? setInfertilitiesForMan(data.data)
            : setInfertilitiesForWoman(data.data);
          setTotalItem(data.total);
        }
      },
      (e) => {
        console.log(e);
      },
    );

  useEffect(() => {
    if (tabKey === 'man' || tabKey === 'woman') {
      getInfertilityList();
    }
  }, [currentPage, tabKey]);

  const groupTabKey = () => {
    return tabKey === 'group-for-woman' ? 'woman' : 'man';
  };

  useEffect(() => {
    if (tabKey === 'group-for-woman' || tabKey === 'group-for-man') {
      getRequest(`infertilities/groups?type=${groupTabKey()}`)
        .then((data) => {
          if (groupTabKey() === 'man') {
            setGroupsForMan(data);
          } else {
            setGroupsForWoman(data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [tabKey]);

  const selectInfertilityWithNote = (item) => {
    const tab = getType();
    if (tab === 'man') {
      const isExisting = selectedManData?.some((data) => data.name === item.name);
      selectedInfertilities.man = isExisting
        ? selectedManData.map((data) =>
            data.name !== item.name ? data : { ...data, instruction: item?.note || '' },
          )
        : [...selectedManData, { name: item.name, instruction: item?.note || '', result: '' }];
    } else {
      const isExisting = selectedWomanData?.some((data) => data.name === item.name);
      selectedInfertilities.woman = isExisting
        ? selectedWomanData.map((data) =>
            data.name !== item.name ? data : { ...data, instruction: item?.note || '' },
          )
        : [...selectedWomanData, { name: item.name, instruction: item?.note || '', result: '' }];
    }
    setSelectedInfertilities({ ...selectedInfertilities });
  };

  const selectInfertility = (item) => {
    const tab = getType();
    if (tab === 'man') {
      if (selectedManData?.some((data) => data.name === item.name)) {
        selectedManData = selectedManData?.filter(
          (data) => data.name !== item.name,
        );
      } else {
        selectedManData = [
          ...selectedManData,
          { name: item.name, instruction: '', result: '' },
        ];
      }
      selectedInfertilities.man = selectedManData;
      setSelectedInfertilities({ ...selectedInfertilities });
    } else {
      if (selectedWomanData?.some((data) => data.name === item.name)) {
        selectedWomanData = selectedWomanData?.filter(
          (data) => data.name !== item.name,
        );
      } else {
        selectedWomanData = [
          ...selectedWomanData,
          { name: item.name, instruction: '', result: '' },
        ];
      }
      selectedInfertilities.woman = selectedWomanData;
      setSelectedInfertilities({ ...selectedInfertilities });
    }
  };

  const deleteGroup = (groupId) => {
    deleteRequest(`infertilities/groups/${groupId}`)
      .then((data) => {
        if (groupTabKey() === 'man') {
          setGroupsForMan(groupsForMan.filter((group) => group.id !== groupId));
        } else {
          setGroupsForWoman(
            groupsForWoman.filter((group) => group.id !== groupId),
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const selectGroup = (group) => {
    if (tabKey === 'man' || groupTabKey() === 'man') {
      let isExist = selectedInfertilityManGroups.some(
        (selectedGroup) => selectedGroup.id === group.id,
      );
      if (!isExist) {
        setSelectedInfertilityManGroups([
          ...selectedInfertilityManGroups,
          group,
        ]);
        group?.itemNames.map((item) => {
          if (!selectedManData?.some((data) => data.name === item)) {
            selectedManData = [
              ...selectedManData,
              {
                name: item,
                instruction: '',
                result: '',
              },
            ];
          }
        });
        selectedInfertilities.man = selectedManData;
        setSelectedInfertilities({ ...selectedInfertilities });
      } else {
        const nameList = group?.itemNames;
        selectedInfertilities.man = selectedManData?.filter(
          (item) => !nameList.includes(item.name),
        );
        setSelectedInfertilities({ ...selectedInfertilities });
        setSelectedInfertilityManGroups(
          selectedInfertilityManGroups.filter(
            (selectedGroup) => selectedGroup.id !== group.id,
          ),
        );
      }
    } else {
      let isExist = selectedInfertilityWomenGroups.some(
        (grp) => grp.id === group.id,
      );
      if (!isExist) {
        setSelectedInfertilityWomenGroups([
          ...selectedInfertilityWomenGroups,
          group,
        ]);
        group?.itemNames.map((item) => {
          if (!selectedWomanData?.some((data) => data.name === item)) {
            selectedWomanData = [
              ...selectedWomanData,
              {
                name: item,
                instruction: '',
                result: '',
              },
            ];
          }
        });
        selectedInfertilities.woman = selectedWomanData;
        setSelectedInfertilities({ ...selectedInfertilities });
      } else {
        const itemList = group.itemNames;
        selectedInfertilities.woman = selectedWomanData?.filter(
          (item) => !itemList.includes(item.name),
        );
        setSelectedInfertilities({ ...selectedInfertilities });
        setSelectedInfertilityWomenGroups(
          selectedInfertilityWomenGroups.filter(
            (selectedGroup) => selectedGroup.id !== group.id,
          ),
        );
      }
    }
  };
  const removeItem = (itemName) => {
    const tab = getType();
    selectedInfertilities[tab] = selectedInfertilities[tab]?.filter(
      (selectedItem) => selectedItem.name !== itemName,
    );
    setSelectedInfertilities({ ...selectedInfertilities });
  };

  const handleExtraInfo = (key, fieldName, val) => {
    const tab = getType();
    selectedInfertilities[tab][key][fieldName] = val;
    setSelectedInfertilities({ ...selectedInfertilities });
  };

  const infertilityList = () => {
    let allData = infertilitiesForWoman;
    let selectedData = selectedWomanData;
    if (tabKey === 'man') {
      allData = infertilitiesForMan;
      selectedData = selectedManData;
    }
    return allData.map((item, index) => {
      const isSelected = selectedData?.some((data) => data.name === item.name);
      return (
        <ItemWithDeleteIcon
          key={index}
          item={item}
          isSelected={isSelected}
          itemClickAction={selectInfertility}
          itemType={`advice`}
          suggestions={elementSuggestions}
          selectItemWithNote={selectInfertilityWithNote}
        />
      );
    });
  };

  const groupList = (allGroup) => {
    const selectedData = groupTabKey() === 'man' ? selectedManData : selectedWomanData;
    return allGroup.map((group, index) => {
      const groupData =
        groupTabKey() === 'man'
          ? selectedInfertilityManGroups
          : selectedInfertilityWomenGroups;
      const isSelected = groupData.some((data) => data.id === group.id);
      return (
        <GroupDropdownItem
          key={index}
          group={group}
          isSelected={isSelected}
          onSelect={selectGroup}
          onDelete={deleteGroup}
          selectedItems={selectedData}
          onToggleItem={(itemName) => selectInfertility({ name: itemName })}
        />
      );
    });
  };

  const handleSearchOrNew = (selectedData) => {
    let tab = getType();
    if (
      !selectedInfertilityManGroups?.some(
        (data) => data.id === selectedData.id,
      ) &&
      selectedData.id !== 'notFound'
    ) {
      let newData = {
        name: selectedData.name,
        type: selectedData.type,
        instruction: '',
        result: '',
      };
      if (tab === 'woman') {
        selectedInfertilities[tab] = [...selectedWomanData, newData];
      } else {
        selectedInfertilities[tab] = [...selectedManData, newData];
      }
      setSelectedInfertilities({ ...selectedInfertilities });
    } else {
      postRequest('infertilities', { name: selectedData.name, type: tab })
        .then((data) => {
          let newResult = {
            name: data.name,
            type: data.type,
            instruction: '',
            result: '',
          };
          if (tab === 'woman') {
            selectedInfertilities[tab] = [...selectedWomanData, newResult];
            setInfertilitiesForWoman([...infertilitiesForWoman, data]);
          } else {
            selectedInfertilities[tab] = [...selectedManData, newResult];
            setInfertilitiesForMan([...infertilitiesForMan, data]);
          }
          setSelectedInfertilities({ ...selectedInfertilities });
        })
        .catch((error) => {
          console.log(error);
        });
    }
    setInfertilitiesInSearch([]);
    setSearchQuery('');
  };

  const handleOnInputChange = (searchKey) => {
    setIsLoading(true);
    const url = `infertilities?type=${tabKey}&name=${searchKey}`;
    setSearchQuery(searchKey);
    getRequest(url)
      .then((data) => {
        if (data.data.length > 0) {
          const customizedResults = data.data.map((item) => {
            return {
              ...item,
              label: item.name,
              value: item.name,
            };
          });
          setInfertilitiesInSearch(customizedResults);
        } else {
          setInfertilitiesInSearch([{ id: 'notFound', name: searchKey }]);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const selectedItemList = (selectedData) => {
    return selectedData?.map((item, index) => {
      return (
        <Row className="selected-item-row" key={`${tabKey}-${index}`}>
          <Col>{item.name}</Col>
          <Col>
            <NoteDropdown
              value={item.instruction || ''}
              onChange={(val) => handleExtraInfo(index, 'instruction', val)}
              placeholder="Add instruction"
              suggestions={allNotes.filter(
                (n) => n.elementType === 'infertility' && n.itemElement?.toLowerCase() === item.name?.toLowerCase(),
              )}
            />
          </Col>
          <Col>
            <Form.Control
              size="sm"
              type="text"
              defaultValue={item.result}
              placeholder="Add result"
              onChange={(e) => handleExtraInfo(index, 'result', e.target.value)}
            />
          </Col>
          <Col md={1} className="text-right">
            <i
              className="far fa-times-circle"
              aria-hidden="true"
              onClick={() => removeItem(item.name)}
            ></i>
          </Col>
        </Row>
      );
    });
  };

  // const getInfertilityIds = () => {
  //   let data = selectedWomanData;
  //   if (tabKey === 'man' || groupTabKey() === 'man') {
  //     data = selectedManData;
  //   }
  //   return data?.map((item) => item.id);
  // };

  const getType = () => {
    return tabKey === 'woman' || tabKey === 'group-for-woman' ? 'woman' : 'man';
  };

  return (
    <>
      <Modal
        show={showInfertility}
        size="lg"
        className="customize-modal-size"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <ModalHeader title={modalTitle} action={setShowInfertility} />
        <Modal.Body>
          <SearchArea
            handleOnInputChange={handleOnInputChange}
            handleSearchOrNew={handleSearchOrNew}
            searchQuery={searchQuery}
            options={infertilitiesInSearch}
            placeholder={'infertility'}
          />
          <Tab.Container
            id="left-tabs-example"
            defaultActiveKey="all-for-woman"
          >
            <InfertilityTabNav
              tabKey={tabKey}
              setTabKey={setTabKey}
              action={setIsInfertilityGroupModal}
              selectedItems={selectedInfertilities[tabKey]}
            />
            <Tab.Content>
              <Tab.Pane eventKey="all-for-woman" className="add-scroll">
                <Row className="complains-area mr-0 ml-0">
                  {infertilityList()}
                </Row>
                <LoadMore
                  currentPage={currentPage}
                  totalItem={totalItem}
                  perPage={perPage}
                  currentPageAction={setCurrentPage}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="group-for-woman" className="add-scroll">
                <Row className="complains-area mr-0 ml-0  mt-1">
                  {groupList(groupsForWoman)}
                </Row>
              </Tab.Pane>
              <Tab.Pane eventKey="all-for-man" className="add-scroll">
                <Row className="complains-area mr-0 ml-0">
                  {infertilityList()}
                </Row>
                <LoadMore
                  currentPage={currentPage}
                  totalItem={totalItem}
                  perPage={perPage}
                  currentPageAction={setCurrentPage}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="group-for-man" className="add-scroll">
                <Row className="complains-area mr-0 ml-0  mt-1">
                  {groupList(groupsForMan)}
                </Row>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
          <InfertilityGroupForm
            itemNames={selectedInfertilities[getType()]?.map(
              (item) => item.name,
            )}
            modalTitle={modalTitle}
            mergeGroup={mergeGroup}
            isInfertilityGroupModal={isInfertilityGroupModal}
            setIsInfertilityGroupModal={setIsInfertilityGroupModal}
            type={getType()}
          />
          <hr className="selected-hr" />
          <div className="selected-item-title">
            {tabKey === 'man' || tabKey === 'group-for-man'
              ? `Selected ${modalTitle} for man`
              : `Selected ${modalTitle} for woman`}
          </div>
          {(tabKey === 'woman' || tabKey === 'group-for-woman') && (
            <div className="selected-item-area">
              {selectedItemList(selectedWomanData)}
            </div>
          )}
          {(tabKey === 'man' || tabKey === 'group-for-man') && (
            <div className="selected-item-area">
              {selectedItemList(selectedManData)}
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default memo(InfertilityModal);
